// 리스트 카드의 비용 표시 계산
// - cost: 실제 적용 비용(매칭 코디 제안=조정 금액 우선, 없으면 공고 원가)
// - original: 공고 원래 금액(dailyPay)
// - showOriginal: 조정이 있어 최초 비용을 별도로 보여줘야 하는지
export const getJobCostInfo = (job: { dailyPay?: string | number | null; additionalPay?: string | number | null }) => {
    const original = Number(job.dailyPay) || 0;
    const raw = job.additionalPay;
    const matched = (raw !== undefined && raw !== null && raw !== '') ? Number(raw) : null;
    const cost = matched !== null ? matched : original;
    const showOriginal = matched !== null && matched !== original;
    return { cost, original, showOriginal };
};
